<div class="fieldset-wrapper" [ngClass]="firstQuestion?.mandatory && firstQuestion?.qsubtype == 72 && (isMandatoryUpfront || (firstQuestion.AnswerText == null && isSubmitted)) ? 'isMandatory' : ''">
  <div *ngIf="imgQuestion?.QuestionImageAndMedia_1 != null" class="questionImageWrapper" [ngClass]="{'question-border': !isMobile}">
    <app-question-image-and-media [questionImageAndMedias]="imgQuestion?.QuestionImageAndMedia_1"
      [imageSize]="imgQuestion?.ImageSize" [isMobile]="isMobile">
    </app-question-image-and-media>
  </div>
<fieldset>
  <legend class="question-option-wrapper" [ngClass]="{'question-border': imgQuestion?.QuestionImageAndMedia_1 == null && !isMobile}">
    <span *ngIf="isDisplayQno" class="question-no">{{firstQuestion.qno}}.</span>
    <span [ngClass]="{'question-text' : group?.isOverAllStyleApplied,
    'question-text-nb': !group?.isOverAllStyleApplied,
    'no-Qno':!isDisplayQno}" id="lbltitle_T{{firstQuestion?.UniqueNumber}}">
      <span *ngIf="questions[0].piping"[innerHTML]="getPipingTitle(questions[0]?.group_no) | headerFooterHtml"></span>
      <span *ngIf="!questions[0].piping" [innerHTML]="group?.gtitle | headerFooterHtml"></span>
      <span *ngIf="group?.QuestionTip" class="tooltip_icon" appTooltip [dataContext]="group?.QuestionTip"
      [IsButtonPanel]="false" [qid]="firstQuestion?.UniqueNumber" tabindex="0" ></span>
      <div *ngIf="imgQuestion?.hasMedia && imgQuestion?.MediaText != null && imgQuestion?.MediaText != ''" class="question-media-text">
        <span>[{{imgQuestion?.MediaText}}]</span>
      </div>
    </span>
  </legend>

    <div *ngIf="imgQuestion?.QuestionImageAndMedia_2 != null" class="questionImageWrapper">
      <app-question-image-and-media [questionImageAndMedias]="imgQuestion?.QuestionImageAndMedia_2"
        [imageSize]="imgQuestion?.ImageSize" [isMobile]="isMobile">
      </app-question-image-and-media>
    </div>
    <div *ngIf="isSignatureControl; else MTBControl">
      <div class="signatureMainWrapper answer-option-wrapper" id="signatureWrapper_{{firstQuestion?.UniqueNumber}}">
        <div *ngIf="setControlValue == 0 && !signatureImg" class="sign-box-wrapper">
          <div class="sign-box" [ngClass]="{'sign-box-invalid': firstQuestion.isValid, 'borderHide': setControlValue > 0}"
             id="signBox_{{firstQuestion?.UniqueNumber}}" [attr.aria-required]="firstQuestion?.mandatory && (isMandatoryUpfront || (firstQuestion.AnswerText == null && isSubmitted))"
            (keydown.space)="setControlValueOnClick(setControlTypeValue)" (click)="setControlValueOnClick(setControlTypeValue)"  tabindex="0" role="button">
            <div class="icon-wrapper scribble"
              *ngIf="group.IsScribbledSignature && setControlTypeValue == 1">
              <div class="sign-icon"></div>
              <div *ngIf="isMobile" class="sign-icon-txt">{{Signature_TapSignHere}}
              </div>
              <div *ngIf="!isMobile" class="sign-icon-txt">{{Signature_ClickSignHere}}
              </div>
            </div>
            <div class="icon-wrapper imageUpload initial-hide"
              *ngIf="group.IsUploadImageSignature && setControlTypeValue == 2">
              <div class="sign-icon"></div>
              <div class="sign-icon-txt">{{Signature_UploadSignature}}</div>
              <div>
                <input type='file' [hidden]="true"
                  id="signatureFile_{{firstQuestion?.qno}}_{{firstQuestion?.UniqueNumber}}" accept=".png, .jpg, .jpeg"
                  data-max-size="1024" class="form-control" (change)="handleFileInput($event.target.files)"
                  tabindex="-1" aria-label="file" aria-hidden="true">
              </div>
            </div>
            <div class="icon-wrapper textSign initial-hide"
              *ngIf="group.IsTypeSignature && setControlTypeValue == 3">
              <div class="sign-icon"></div>
              <div class="sign-icon-txt">{{Signature_TypeHere}}</div>
            </div>
          </div>
          <div class="preview-sign-options-wrapper ">
            <div class="preview-sign-opt-container">
              <div class="sign-opt scribble" (keydown.space)="setControlType(1)" (click)="setControlType(1)" title="Scribble/Draw" tabindex="0" role="button"
                [ngClass]="{'active': setControlTypeValue == 1}"
                *ngIf="group.IsScribbledSignature && (group.IsUploadImageSignature || group.IsTypeSignature)"></div>
              <div class="sign-opt imageUpload"  (keydown.space)="setControlType(2)" (click)="setControlType(2)" title="Upload​" tabindex="0" role="button"
                [ngClass]="{'active': setControlTypeValue == 2}"
                *ngIf="group.IsUploadImageSignature  && (group.IsScribbledSignature || group.IsTypeSignature)"></div>
              <div class="sign-opt textSign"  (keydown.space)="setControlType(3)" (click)="setControlType(3)" title="Type" tabindex="0" role="button"
                [ngClass]="{'active': setControlTypeValue == 3}"
                *ngIf="group.IsTypeSignature  && (group.IsUploadImageSignature || group.IsScribbledSignature)"></div>
            </div>
          </div>
        </div>

        <div *ngIf="setControlValue == 1  && !signatureImg" class="questionsign_scribble_container"
          id="scribble_container_{{firstQuestion?.UniqueNumber}}" tabindex="0">
          <signature-pad class="questionSignatureCanvas" [options]="signaturePadOptions" (onBeginEvent)="drawStart()"
            (onEndEvent)="drawComplete()"></signature-pad>
        </div>

        <div *ngIf="setControlValue == 3 && !signatureImg" class="editable-signInput">
          <input type="text" id="Q1__{{firstQuestion?.UniqueNumber}}_T_ID" maxlength="100" (blur)="blurData($event)" (keyup)="blurData($event)"
            [ngClass]="{'montserrat': selectFontValue == -1,'homemade-apple': selectFontValue == 1, 'windsong': selectFontValue == 2, 'allura':selectFontValue == 3,
              'fuggles': selectFontValue == 4, 'kristi': selectFontValue == 5, 'Dawing-of-newDay': selectFontValue == 6,
              'Charmonman': selectFontValue == 7, 'Nothingyou-could-do': selectFontValue == 8, 'Allison': selectFontValue == 9,
              'Zeyada': selectFontValue == 10, 'Mrs-Saint-Delafield': selectFontValue == 11 }"
               [(ngModel)]="textSignatureValue" [ngStyle]="{'font-size': textFontSize()}" />


          <div *ngIf="textSignatureValue">
            <div *ngIf="textSignatureValue && ischangeStyle" id="changeStyle_{{firstQuestion?.UniqueNumber}}_ID"
              class="o-menu-list changeSignatureStyleDD"  role="button" tabindex="0" (keydown.esc)="resetTimer();">

              <div *ngFor="let font of fontDataForSignature">
                <div id="{{font.Font_id}}_{{firstQuestion?.UniqueNumber}}" class="o-menu-list-item"
                  [ngClass]="{'montserrat': font.Font_id == -1,'homemade-apple': font.Font_id == 1, 'windsong': font.Font_id == 2, 'allura': font.Font_id == 3,
              'fuggles': font.Font_id == 4, 'kristi': font.Font_id == 5, 'Dawing-of-newDay': font.Font_id == 6,
              'Charmonman': font.Font_id == 7, 'Nothingyou-could-do': font.Font_id == 8, 'Allison': font.Font_id == 9,
               'Zeyada': font.Font_id == 10, 'Mrs-Saint-Delafield': font.Font_id == 11, 'changeStyledropdownActive': selectFontValue == font.Font_id}"
               (keydown.space)="applyFontStyle(font)" (click)="applyFontStyle(font)">
                  <span role="option" tabindex="0">{{ textSignatureValue}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="loader-box" *ngIf="setControlValue == 2 && isLoaderOnImage">
          <div class="attachedLoader" style="margin: 0 auto; display: block; text-align:center; padding-top: 55px;"
            id="loader_{{firstQuestion?.UniqueNumber}}">
            <div>
              <div class="line" style="width: 4px; height: 30px; margin: 3.33333px; border-radius: 3.33333px;">
              </div>
              <div class="line" style="width: 4px; height: 30px; margin: 3.33333px; border-radius: 3.33333px;">
              </div>
              <div class="line" style="width: 4px; height: 30px; margin: 3.33333px; border-radius: 3.33333px;">
              </div>
            </div>
          </div>
        </div>


        <div class="signature-image" *ngIf="signatureImg && !isLoaderOnImage" role="img" tabindex="0" id="img_{{firstQuestion?.UniqueNumber}}">
          <img src='{{signatureImg}}' id='image_{{firstQuestion?.UniqueNumber}}_ID' />
        </div>

        <div class="typefont-wrapper" *ngIf="setControlValue > 0">
          <div class="sign-inline-element" *ngIf="textSignatureValuelength() && setControlValue == 3 && !signatureImg" aria-haspopup="true">
            <div class="changeStyleIcon" title="Change style​" role="button" tabindex="0"
              (click)="fontChange(firstQuestion?.UniqueNumber)" (keydown.space)="fontChange(firstQuestion?.UniqueNumber)"></div>
          </div>

          <div class="sign-inline-element sign-btn-wrapper">
            <button class="signature-btn signatureOK" title="{{Signature_SaveConfirm}}" type="button" *ngIf="isSetImage && !signatureImg"
              (click)="savePad(setControlValue)"> {{Signature_SaveConfirm}} </button>
            <button class="signature-btn signatureClear" title="{{Signature_Clear}}" type="button" (click)="clearSignature()"> {{Signature_Clear}} </button>
          </div>
        </div>

        <div *ngIf="firstQuestion.isValid" class="alertMessage" [ngClass]="{'errorMsg-fullwidth': isErrormsg_fullwidth}" role="alert"
          id="lblalert_{{firstQuestion?.UniqueNumber}}">
          <span class="alertMessage_Icon"></span> <span class="alertText">{{firstQuestion.error_msg}}</span>
        </div>
        <ng-container *ngIf="isNewParticipation  && (surveyFormat == 1 || surveyFormat == 2)">
          <div  class="ques-response-btn-div">
            <!-- <input type="button" value="{{newParticipationBtnText}}" class="ques-response-btn" (click)="gotoNextQuestion(questions[0],$event.target)"/> -->
            <button *ngIf="isNewParticipationButton && (isAnsChange||isPreReadQn)" type="button" class="ques-response-btn" (keyup.Space)="gotoNextQuestionKeyboard(questions,$event)" (click)="gotoNextQuestion(questions[0],$event.target)">{{newParticipationBtnText}}</button>
          </div>
        </ng-container>
      </div>
    </div>

    <ng-template #MTBControl>

      <div class="fieldset-wrapper-scroll-cont">
        <div class="div-scroll-btn"><span class="div-scroll-symbol"></span></div>
        <div class="fieldset-wrapper-scroll">
          <div style="display: table; width: 100%;" class="answerParent">
            <div class="answer-option-wrapper mtb-box"  >

              <!-- Text Box -->
              <!-- <div *ngIf="question.qtype == 'T'" class="demographics-wrapper">
                  <app-text-box [JsonData]="GetQuestionsString(question)" [isDisplayQno]="false" [isDisplaySubQno]="true"
                    [isMandatoryUpfront]="isMandatoryUpfront" (ChangeAnswersData)="UpdateQuestionsData($event)">
                  </app-text-box>
                </div> -->

              <div *ngIf="(matrix?.MultiColumnCount > 1 && !isMobile) else SingleColumnCode">
                <div class="column-struct-mtb" *ngFor="let questionsArr of questionsArray">
                  <table cellpadding="0" cellpadding="3" style="width: 100%;" [ngStyle]="{'min-width': matrix?.MultiColumnCount == 2? '600px':'900px'}" role="presentation">
                    <ng-container *ngFor="let questions of questionsArr; let k = index">
                      <tr>
                        <!-- it shows horizontal and vertical data-->
                        <td class="mtb-td" *ngFor="let question of questions; let i = index" [style.width]="columnWidth + '%'">
                          <div class="mtb-wrapper"
                            [ngClass]="{ 'attachment-cont' : question.qsubtype == 71, 
                                         'attachment-validator' :(question.qsubtype == 71 && k < questionsArr.length-1), 
                                         'mtb-single-image' : HasSingleImageClass(i), 
                                         'mtb-multi-image' : HasMultiImageClass(i),
                                         'mtb-email':question.qsubtype == 31 && !isMobile,
                                        'mtb-left-title': getMtbTItleLocation() == 0,
                                        'mtb-right-title': getMtbTItleLocation() == 1,
                                        'mtb-above-title': getMtbTItleLocation() == 2,
                                        'mtb-below-title': getMtbTItleLocation() == 3,
                                      'mtb-single-col':getMultiColumnCount()== 1}">
                            <div class="mtb-media">
                              <app-answer-media [AnswerMedias]="GetAnswerMedias(question)"></app-answer-media>
                              <app-answer-images [AnswerImages]="GetAnswerImages(question)"></app-answer-images>
                            </div>
                            <div class="mtb-tb-container">
                              <app-text-box [JsonData]="GetQuestionsString(question)" [isDisplayQno]="false"
                                [isDisplaySubQno]="GetSubQnNumber()" [isMandatoryUpfront]="isMandatoryUpfront"
                                [isAnySubQMandatory]="isAnySubQMandatory"
                                (ChangeAnswersData)="UpdateQuestionsData($event)" (AnsChangecall)="AnsChangecall($event)" [isMTB]="true" [isDemographics]="false">
                              </app-text-box>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <!-- Vertical Spacing TR -->
                      <tr>
                        <td class="{{verticalClassName}}" [attr.colspan]="questions.length"></td>
                      </tr>
                    </ng-container>
                  </table>
                </div>
              </div>

              <ng-template #SingleColumnCode>
                <div *ngFor="let question of questions | callBack: getHiddenQuestions;let i = index">
                  <div class="mtb-wrapper {{getAnsImageCSS()}}"
                  [ngClass]="{ 'attachment-cont' : question.qsubtype == 71,
                  'attachment-validator' : (question.qsubtype == 71 && i < questions.length-1),
                  'mtb-email':question.qsubtype == 31 && !isMobile,'mtb-left-title': getMtbTItleLocation() == 0,
                  'mtb-right-title': getMtbTItleLocation() == 1,
                  'mtb-above-title': getMtbTItleLocation() == 2,
                  'mtb-below-title': getMtbTItleLocation() == 3,
                'mtb-single-col':getMultiColumnCount()== 1 }">
                    <div class="mtb-media">
                      <app-answer-media [AnswerMedias]="GetAnswerMedias(question)"></app-answer-media>
                      <app-answer-images [AnswerImages]="GetAnswerImages(question)"></app-answer-images>
                    </div>
                    <div class="mtb-tb-container">
                      <app-text-box [JsonData]="GetQuestionsString(question)" 
                        [isDisplayQno]="false" [isDisplaySubQno]="GetSubQnNumber()"
                        [isAnySubQMandatory]="isAnySubQMandatory"
                        [isMandatoryUpfront]="isMandatoryUpfront" (ChangeAnswersData)="UpdateQuestionsData($event)" (AnsChangecall)="AnsChangecall($event)" [isMobile]="isMobile"
                        [isMTB]="true" [isGrid]="isMobile" [isDemographics]="false">
                      </app-text-box>
                    </div>
                  </div>
                  <!-- Vertical Spacing -->
                  <div class="{{verticalClassName}}"></div>
                </div>
              </ng-template>
              <ng-container *ngIf="isNewParticipation  && (surveyFormat == 1 || surveyFormat == 2)">
                <div  class="ques-response-btn-div">
                  <!-- <input type="button" value="{{newParticipationBtnText}}" class="ques-response-btn" (click)="gotoNextQuestion(questions[0],$event.target)"/> -->
                  <button *ngIf="isNewParticipationButton && (isAnsChange||isPreReadQn)" type="button" class="ques-response-btn" (keyup.Space)="gotoNextQuestionKeyboard(questions,$event)" (click)="gotoNextQuestion(questions[0],$event.target)">{{newParticipationBtnText}}</button>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </ng-template>

  </fieldset>
</div>
